"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _ContentLayout = require("../../../../components/ContentLayout");
var _PhoneAuthForm = require("../../../../components/PhoneAuthForm");
var _tracking = require("../../../../utils/tracking");
var _validation = require("../../../../utils/validation");
var _selectors = require("./selectors");
var _autoFocusDisabled = require("../../../../selectors/autoFocusDisabled");
var _phoneAuth = require("../../../../actions/phoneAuth");
var _checkPhone = require("../../../../actions/phoneAuth/checkPhone");
var _state = require("../../../../actions/state");
var _source = require("../../../../selectors/source");
var _constants = require("./constants");
var _RootContainer = require("../../../RootContainer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FormContainer = _ref => {
  let {
    useSelector,
    useDispatch
  } = _ref;
  const dispatch = useDispatch();
  const {
    hideOtherAuthMethodsButton
  } = React.useContext(_RootContainer.RootContext);
  const isSubmitting = useSelector(_selectors.isPhoneAuthFormSubmitting);
  const isAutosubmitEnabled = useSelector(_selectors.isAutosubmitEnabled);
  const phone = useSelector(_selectors.phoneSelector);
  const hasAsyncPhoneError = useSelector(_selectors.hasPhoneErrorSelector);
  const isPhoneInvalid = useSelector(_selectors.isPhoneInvalidSelector);
  const phoneError = useSelector(_selectors.phoneErrorSelector);
  const autoFocusDisabled = useSelector(_autoFocusDisabled.selectAutoFocusDisabled);
  const source = useSelector(_source.sourceSelector);

  // FORM
  const [changed, setChanged] = React.useState(false);
  const [touched, setTouched] = React.useState(false);
  const [isBlocked, setBlocked] = React.useState(false);

  // PHONE
  const phoneRef = React.useRef(null);
  const handleChangePhone = React.useCallback(value => {
    const newValue = value.replace(/\s/gi, '');
    dispatch((0, _phoneAuth.changePhone)(newValue));
    setChanged(true);
  }, [dispatch]);
  const switchView = React.useCallback(() => {
    (0, _tracking.trackChangeLoginFlowTo)('email', source);
    dispatch((0, _state.resetToUsernameAuth)());
  }, [dispatch, source]);
  const handleSubmit = React.useCallback(() => {
    setTouched(true);
    (0, _tracking.trackPhoneAuthResumeButtonClick)(source);
    if (isPhoneInvalid) {
      if (phoneRef.current) {
        phoneRef.current.focus();
      }
    }
    dispatch((0, _checkPhone.checkPhone)());
    setChanged(false);
  }, [dispatch, isPhoneInvalid, source]);
  React.useEffect(() => {
    if ((0, _validation.isPhone)(phone) && isAutosubmitEnabled) {
      handleSubmit();
      dispatch((0, _phoneAuth.toggleAutosubmit)(false));
    }
  }, [dispatch, phone, isAutosubmitEnabled, handleSubmit]);
  React.useEffect(() => {
    if (phoneError && _constants.notice.includes(phoneError)) {
      setBlocked(true);
    }
  }, [phoneError]);
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement(_PhoneAuthForm.PhoneAuthForm, {
    autoFocusDisabled: autoFocusDisabled,
    phoneRef: phoneRef,
    handleSubmit: handleSubmit,
    isSubmitting: isSubmitting,
    phone: phone,
    onPhoneChange: handleChangePhone,
    phoneError: !changed && !isBlocked && phoneError || undefined,
    isPhoneInvalid: touched && (isPhoneInvalid || !changed && hasAsyncPhoneError),
    onSwitchAuthType: switchView,
    isBlocked: isBlocked,
    hideOtherAuthMethodsButton: hideOtherAuthMethodsButton
  }));
};
exports.FormContainer = FormContainer;